<template>
	<div class="content">
		<div class="section">
			<div class="search-top">
				<div class="left">
					<label class="input-label">검색키워드</label>
					<input
						class="form-control"
						type="text"
						placeholder="물건명, 주소, 소유자, 전소유자, 전화번호"
						maxlength="80"
						v-model="searchOptions_.keyword"
						@keyup.enter="btnSearch"
					/>
					<label class="input-label">매물상태</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.state.st" @change="btnStOptionWithSearch" />
						<span class="checkbox"></span>
						<span class="text">전체</span>
					</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.state.st_" :value="'ready'" @change="btnSearch" />
						<span class="checkbox"></span>
						<span class="text">준비</span>
					</label>

					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.state.st_" :value="'done'" @change="btnSearch" />
						<span class="checkbox"></span>
						<span class="text">매물</span>
					</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.state.st_" :value="'hold'" @change="btnSearch" />
						<span class="checkbox"></span>
						<span class="text">보류</span>
					</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.state.st_" :value="'sell'" @change="btnSearch" />
						<span class="checkbox"></span>
						<span class="text">매각</span>
					</label>
				</div>
				<div class="right">
					<button type="button" class="btn search" @click="btnSearch"><b-icon-search /></button>
					<button type="button" class="btn list" @click="isDetailSearchPopupShow = true">
						<b-icon-funnel-fill />
					</button>
				</div>
			</div>
			<div class="map-wrap">
				<!-- <div id="map" class="map"></div> -->
				<div class="map" :class="{ active: isMapListActive }">
					<!-- 0130 매물상세 -->

					<naver-map
						:mapOptions="mapOptions"
						:initLayers="initLayers"
						@onLoad="onLoadMap($event)"
						@idle="onIdleDebounced"
						@zoom_changed="onZoomChanged($event)"
					>
						<naver-marker
							v-for="(item, idx) in itemList"
							:key="'1_' + item.bid + '_' + idx"
							:latitude="item.pt.y"
							:longitude="item.pt.x"
							@onLoad="onLoadMarker($event, item)"
						>
						</naver-marker>
						<naver-marker
							v-for="(item, idx) in itemDongList"
							:key="'2_' + item[0].id + '_' + idx"
							:latitude="item[0].pt.y"
							:longitude="item[0].pt.x"
							@onLoad="onLoadDongMarker($event, item)"
						>
						</naver-marker>
						<naver-marker
							v-for="(item, idx) in itemGuList"
							:key="'3_' + item[0].id + '_' + idx"
							:latitude="item[0].pt.y"
							:longitude="item[0].pt.x"
							@onLoad="onLoadDongMarker($event, item)"
						>
						</naver-marker>
						<naver-marker
							v-for="(item, idx) in itemSidoList"
							:key="'4_' + item[0].id + '_' + idx"
							:latitude="item[0].pt.y"
							:longitude="item[0].pt.x"
							@onLoad="onLoadDongMarker($event, item)"
						>
						</naver-marker>
						<naver-polygon
							v-for="(item, idx) in itemBizList"
							:key="'5_' + item.id + '_' + idx"
							:paths="item.pos"
							:strokeColor="'red'"
							:strokeWeight="5"
							@onLoad="onLoadPolygon($event)"
							@mouseover="onMouseupPolygon($event, item.name)"
							@mouseout="onMouseoutPolygon($event)"
						/>
					</naver-map>

					<div class="map-btn">
						<button type="button" class="btn" @click="btnZoomLevel(1)"><b-icon-plus-lg /></button>
						<button type="button" class="btn" @click="btnZoomLevel(-1)"><b-icon-dash-lg /></button>
						<button type="button" class="btn" v-bind:class="{ active: isCad }" @click="btnMapType()">지적도</button>
						<button
							type="button"
							class="btn"
							v-bind:class="{ active: isBizActive }"
							@click="btnBizActive(!isBizActive)"
						>
							상권
						</button>
					</div>

					<button type="button" class="btn btn-fold" @click="btnMapListActive(!isMapListActive)">
						<b-icon-chevron-right v-if="!isMapListActive" />
						<b-icon-chevron-left v-else />
					</button>
				</div>
				<span v-show="isTooltipShow" class="map-tooltip">{{ tooltipName }}</span>
				<div class="map-list" :class="{ active: !isMapListActive }">
					<div class="section-tit">물건목록</div>
					<div class="table-wrap">
						<table class="table">
							<colgroup>
								<col width="10%" />
								<col width="40%" />
								<col width="20%" />
								<col width="20%" />
								<col width="10%" />
							</colgroup>
							<tr class="sticky">
								<th>상태</th>
								<th>물건명</th>
								<th>대지면적/연면적</th>
								<th>매매가격</th>
								<th>수익률</th>
							</tr>
							<tr
								v-for="item in pageItemList"
								:key="'list_' + item.bid"
								@click="btnItemPage(item.pt.x, item.pt.y, 21, item.bid)"
								v-bind:class="{ bg: item.bid == isInfo }"
							>
								<td
									v-bind:class="{
										'text-primary': item.state == 'done',
										'text-secondary': item.state == 'ready',
										'text-dark': item.state == 'hold',
										'text-danger': item.state == 'sell',
									}"
								>
									{{ ITEM_STATE[item.state] }}
								</td>
								<td>{{ item.building_name }}</td>
								<td>{{ $formatArea(item.land_size_p) }}(평)<br />{{ $formatArea(item.total_size_p) }}(평)</td>
								<td>{{ formatMoney(item.sell_price, this.MONEY_FORMAT_TYPE.MUCH) }}</td>
								<td>{{ item.earning_rate }}</td>
							</tr>
						</table>
					</div>

					<ul class="pagination b-pagination pagination-sm" v-if="pageData != null && pageData.list.length">
						<li class="page-item" v-bind:class="{ disabled: 1 == page }">
							<button type="button" class="page-link" @click="getItemPage(1)">
								<b-icon-chevron-double-left />
							</button>
						</li>

						<li class="page-item" v-bind:class="{ disabled: pageData.first == null }">
							<button
								type="button"
								class="page-link"
								@click="pageData.first !== null ? getItemPage(pageData.first) : ''"
							>
								<b-icon-chevron-left />
							</button>
						</li>
						<li
							v-for="pg in pageData.list"
							v-bind:key="'pg_' + pg"
							class="page-item"
							v-bind:class="{ active: pageData.currentPage == pg }"
						>
							<button type="button" class="page-link" @click="getItemPage(pg)">{{ pg }}</button>
						</li>
						<li class="page-item" v-bind:class="{ disabled: pageData.end == null }">
							<button type="button" class="page-link" @click="pageData.end !== null ? getItemPage(pageData.end) : ''">
								<b-icon-chevron-right />
							</button>
						</li>

						<li class="page-item" v-bind:class="{ disabled: pageData.totalPage == page }">
							<button type="button" class="page-link" @click="getItemPage(pageData.totalPage)">
								<b-icon-chevron-double-right />
							</button>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
	<div v-if="isDetailSearchPopupShow" class="popup-wrap">
		<div class="dim" @click="isDetailSearchPopupShow = false"></div>
		<div class="popup lg">
			<div class="popup-tit">
				상세검색
				<button type="button" class="btn btn-close" @click="isDetailSearchPopupShow = false"><b-icon-x-lg /></button>
			</div>
			<div class="popup-con">
				<table class="table type-input">
					<colgroup>
						<col width="5%" />
						<col width="11%" />
						<col width="5%" />
						<col width="11%" />
						<col width="5%" />
						<col width="11%" />
						<col width="5%" />
						<col width="11%" />
						<col width="5%" />
						<col width="11%" />
						<col width="5%" />
						<col width="11%" />
					</colgroup>
					<tr>
						<th>검색키워드</th>
						<td colspan="3">
							<input
								class="form-control"
								type="text"
								placeholder="물건명, 주소, 소유자, 전소유자, 전화번호"
								maxlength="80"
								v-model="searchOptions_.keyword"
							/>
						</td>
						<th>매물상태</th>
						<td colspan="3">
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.state.st" @change="btnStOption" />
								<span class="checkbox"></span>
								<span class="text">전체</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.state.st_" :value="'ready'" />
								<span class="checkbox"></span>
								<span class="text">준비</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.state.st_" :value="'done'" />
								<span class="checkbox"></span>
								<span class="text">매물</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.state.st_" :value="'hold'" />
								<span class="checkbox"></span>
								<span class="text">보류</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.state.st_" :value="'sell'" />
								<span class="checkbox"></span>
								<span class="text">매각</span>
							</label>
						</td>
						<th>전화번호</th>
						<td colspan="3">
							<input class="form-control" type="text" v-model="searchOptions_.phone" />
						</td>
					</tr>
					<tr>
						<th>물건명</th>
						<td colspan="3">
							<input class="form-control" type="text" placeholder="물건명" v-model="searchOptions_.bName" />
						</td>
						<th>상태</th>
						<td>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.stList" :value="'A'" />
								<span class="checkbox"></span>
								<span class="text">A</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.stList" :value="'B'" />
								<span class="checkbox"></span>
								<span class="text">B</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.stList" :value="'C'" />
								<span class="checkbox"></span>
								<span class="text">C</span>
							</label>
						</td>
						<th>물건번호</th>
						<td>
							<input class="form-control" type="number" placeholder="물건번호" v-model="searchOptions_.bId" />
						</td>
						<th>매물종류</th>
						<td colspan="3">
							<VueMultiselect
								v-model="searchOptions_.cateList"
								tag-placeholder="Add this as new tag"
								placeholder="매물종류"
								label="name"
								track-by="id"
								:options="bdCateList"
								:multiple="true"
								:taggable="true"
								deselect-label="Can't remove this value"
							>
								<template v-slot:tag="{ option, remove }">
									<span class="custom__tag">
										<span>
											{{ option.name }}
										</span>
										<span class="custom__remove" @click="remove(option)">&times;</span>
									</span>
								</template>

								<template v-slot:option="props">
									<div class="option__desc">
										<span class="option__title">{{ props.option.name }}</span>
									</div>
								</template>
							</VueMultiselect>
						</td>
					</tr>
					<tr>
						<th>소유자명</th>
						<td colspan="3">
							<input class="form-control" type="text" placeholder="소유자명" v-model="searchOptions_.oName" />
						</td>
						<th>전소유자명</th>
						<td colspan="3">
							<input class="form-control" type="text" placeholder="전소유자명" v-model="searchOptions_.preOName" />
						</td>
						<th>매매일자</th>
						<td colspan="3">
							<input class="form-control xsm" type="date" v-model="searchOptions_.sellDate_S" />
							<b-icon-arrow-up />
							<input class="form-control xsm" type="date" v-model="searchOptions_.sellDate_E" />
							<b-icon-arrow-down />
						</td>
					</tr>
					<tr>
						<th>용도지역</th>
						<!-- v-model="searchOptions_.useList" -->
						<td colspan="3">
							<VueMultiselect
								v-model="searchOptions_.useList"
								tag-placeholder="Add this as new tag"
								placeholder="용도지역"
								label="name"
								track-by="id"
								:options="useAreaList"
								:multiple="true"
								:taggable="true"
								deselect-label="Can't remove this value"
							>
								<template v-slot:tag="{ option, remove }">
									<span class="custom__tag">
										<span>
											{{ option.name }}
										</span>
										<span class="custom__remove" @click="remove(option)">&times;</span>
									</span>
								</template>

								<template v-slot:option="props">
									<div class="option__desc">
										<span class="option__title">{{ props.option.name }}</span>
									</div>
								</template>
							</VueMultiselect>
							<!-- <select class="form-control">
								<option></option>
							</select> -->
						</td>
						<th>매물금액</th>
						<td colspan="3">
							<input class="form-control xsm" type="number" placeholder="억이상" v-model="searchOptions_.sellPrice_S" />
							<input class="form-control xsm" type="number" placeholder="억이하" v-model="searchOptions_.sellPrice_E" />
						</td>
						<th>리모델링일</th>
						<td colspan="3">
							<input class="form-control xsm" type="date" v-model="searchOptions_.remodelDate_S" />
							<b-icon-arrow-up />
							<input class="form-control xsm" type="date" v-model="searchOptions_.remodelDate_E" />
							<b-icon-arrow-down />
						</td>
					</tr>
					<tr>
						<th>대지평수</th>
						<td colspan="3">
							<input
								class="form-control xsm"
								type="text"
								placeholder="평이상"
								v-model="searchOptions_.lp_S"
								@keyup="searchOptions_.lm_S = $py_m2_ex(searchOptions_.lp_S)"
							/>
							<input
								class="form-control xsm"
								type="text"
								placeholder="평이하"
								v-model="searchOptions_.lp_E"
								@keyup="searchOptions_.lm_E = $py_m2_ex(searchOptions_.lp_E)"
							/>
							<br />
							<input
								class="form-control xsm"
								type="text"
								placeholder="㎡이상"
								v-model="searchOptions_.lm_S"
								@keyup="searchOptions_.lp_S = $m2_py_ex(searchOptions_.lm_S)"
							/>
							<input
								class="form-control xsm"
								type="text"
								placeholder="㎡이하"
								v-model="searchOptions_.lm_E"
								@keyup="searchOptions_.lp_E = $m2_py_ex(searchOptions_.lm_E)"
							/>
						</td>
						<th>건물평수</th>
						<td colspan="3">
							<input
								class="form-control xsm"
								type="text"
								placeholder="평이상"
								v-model="searchOptions_.sizeP_S"
								@keyup="searchOptions_.sizeM_S = $py_m2_ex(searchOptions_.sizeP_S)"
							/>
							<input
								class="form-control xsm"
								type="text"
								placeholder="평이하"
								v-model="searchOptions_.sizeP_E"
								@keyup="searchOptions_.sizeM_E = $py_m2_ex(searchOptions_.sizeP_E)"
							/>
							<br />
							<input
								class="form-control xsm"
								type="text"
								placeholder="㎡이상"
								v-model="searchOptions_.sizeM_S"
								@keyup="searchOptions_.sizeP_S = $m2_py_ex(searchOptions_.sizeM_S)"
							/>
							<input
								class="form-control xsm"
								type="text"
								placeholder="㎡이하"
								v-model="searchOptions_.sizeM_E"
								@keyup="searchOptions_.sizeP_E = $m2_py_ex(searchOptions_.sizeM_E)"
							/>
						</td>
						<th>준공일자</th>
						<td colspan="3">
							<input class="form-control xsm" type="date" v-model="searchOptions_.buildDate_S" />
							<b-icon-arrow-up />
							<input class="form-control xsm" type="date" v-model="searchOptions_.buildDate_E" />
							<b-icon-arrow-down />
						</td>
					</tr>
					<tr>
						<th>연수익률</th>
						<td colspan="3">
							<input class="form-control xsm" type="number" v-model="searchOptions_.er_S" />
							%<b-icon-arrow-up />
							<input class="form-control xsm" type="number" v-model="searchOptions_.er_E" />
							%<b-icon-arrow-down />
						</td>
						<th>도로너비</th>
						<td colspan="3">
							<input class="form-control xsm" type="number" v-model="searchOptions_.roadWide_S" />
							<b-icon-arrow-up />
							<input class="form-control xsm" type="number" v-model="searchOptions_.roadWide_E" />
							<b-icon-arrow-down />
							<br />
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.roadConer" :true-value="'Y'" :false-value="''" />
								<span class="checkbox"></span>
								<span class="text">코너</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="searchOptions_.roadDual" :true-value="'Y'" :false-value="''" />
								<span class="checkbox"></span>
								<span class="text">양면</span>
							</label>
						</td>
						<th>토지평단가</th>
						<td>
							<input class="form-control xsm" type="number" v-model="searchOptions_.landSizePy" />
							<b-icon-arrow-down />
						</td>
						<th>연면적평단가</th>
						<td>
							<input class="form-control xsm" type="number" v-model="searchOptions_.totalSizePy" />
							<b-icon-arrow-down />
						</td>
					</tr>
					<tr>
						<th>주변역</th>
						<td>
							<input class="form-control xsm" type="text" v-model="searchOptions_.sub" />
						</td>
						<th>거리</th>
						<td>
							<input class="form-control xsm" type="text" v-model="searchOptions_.dis" />
							<b-icon-arrow-down />
						</td>
						<th>도로명</th>
						<td>
							<input class="form-control xsm" type="text" v-model="searchOptions_.roadName" />
						</td>
						<th>담당자</th>
						<!-- v-model="searchOptions_.memUid" -->
						<td>
							<select class="form-control select xsm" v-model="searchOptions_.memUid">
								<option value="">담당자 선택</option>
								<option v-for="m in memList" :key="m.mem_uid" :value="m.mem_uid">
									{{ m.mem_name }} {{ m.mem_rank_name }}
								</option>
							</select>
						</td>
						<th>팀</th>
						<!-- DC: 부서와 팀을 '팀' 하나로 합쳤다. 하위 팀(cateId)은 고르지 않으므로 늘 빈 값이 나간다(요청 문자열은 그대로). -->
						<td colspan="3">
							<select
								v-model="searchOptions_.teamId"
								class="form-control xsm select"
								@change="searchOptions_.cateId = ''"
							>
								<option value="" selected>팀</option>
								<option :value="t.ind_cfg_uid" :key="'team_' + t.ind_cfg_uid" v-for="t in teamList">
									{{ t.cfg_val1 }}
								</option>
							</select>
						</td>
					</tr>
					<tr>
						<th>층수</th>
						<td colspan="3">
							<input class="form-control xsm" type="text" placeholder="층이상" v-model="searchOptions_.floor_S" />
							<input class="form-control xsm" type="text" placeholder="층이하" v-model="searchOptions_.floor_E" />
						</td>
						<th>매물등록일자</th>
						<td colspan="3">
							<input class="form-control xsm" type="date" v-model="searchOptions_.regDate_S" />
							<b-icon-arrow-up />
							<input class="form-control xsm" type="date" v-model="searchOptions_.regDate_E" />
							<b-icon-arrow-down />
						</td>
						<th></th>
						<td colspan="3"></td>
					</tr>
				</table>
				<div class="btn-wrap">
					<button type="button" class="btn btn-btn btn-secondary" @click="clearSearch">초기화</button>
					<button type="button" class="btn btn-primary" @click="btnSearch">검색</button>
				</div>
			</div>
		</div>
	</div>

	<!-- <div v-if="isDetailPopupShow" class="popup-wrap">
		<div class="dim"></div>
		<div class="popup full">
			<div class="popup-tit">
				상세
				<button type="button" class="btn btn-close" @click="isDetailPopupShow = false"><b-icon-x-lg /></button>
			</div>
			<div class="popup-con">
				<MapDetail :bid="this.isDetailPopupShow" />
			</div>
		</div>
	</div> -->
</template>

<script>
// import MapDetail from '@/views/MapDetail.vue';
import { NaverMap, NaverMarker, NaverPolygon } from 'vue3-naver-maps';
import VueMultiselect from 'vue-multiselect';
// import axios from 'axios';/

export default {
	name: 'MapSearch',
	components: {
		NaverMap,
		NaverMarker,
		NaverPolygon,
		VueMultiselect,
		// NaverInfoWindow,
	},
	data() {
		return {
			map: null,
			mapType: null,
			marker: {},
			marker2: null,
			polygon: null,
			infoWindow: null,
			infoList: [],
			isInfo: null,
			isCad: false, //지적도
			idleTimer: null,
			isLoadingMarkers: false,
			loadRequestId: 0,
			pendingRefresh: false,

			thisItem: null,
			itemList: [],
			itemDongList: [],
			itemGuList: [],
			itemSidoList: [],
			itemBizList: [],

			pageItemList: [],

			zoom: 18,

			mapOptions: {
				latitude: 37.51347, // 지도 중앙 위도
				longitude: 127.041722, // 지도 중앙 경도
				zoom: 18,
				zoomControl: false,
				zoomControlOptions: { position: 'TOP_RIGHT' },
			},
			initLayers: ['BACKGROUND', 'BACKGROUND_DETAIL', 'POI_KOREAN', 'TRANSIT', 'ENGLISH'],

			isMapListActive: false,
			isDetailSearchPopupShow: false,
			isBizActive: false,
			isDetailPopupShow: false,

			MONEY_FORMAT_TYPE: {
				LITTLE: 'LITTLE',
				MUCH: 'MUCH',
				LOAN: 'LOAN',
				RANGE: 'RANGE',
				TAX: 'TAX',
				MOBILE: 'MOBILE',
				MOBILE2: 'MOBILE2',
			},

			ITEM_STATE: { sell: '매각', ready: '준비', hold: '보류', done: '매물' },
			searchOptions: {
				mode: 0,
				keyword: '',
				state: {
					st: false,
					st_: ['done'],
				},
				bName: '', //물건명
				oName: '', //소유자명
				useList: [], //용도지역
				lp_S: '', //대지평수
				lp_E: '',
				lm_S: '', //대지면적
				lm_E: '',
				er_S: '', //연수익률
				er_E: '',
				sub: '', //주변역
				dis: '', //거리
				floor_S: '', //층수
				floor_E: '',
				stList: [], //상태
				bId: '', //물건번호
				preOName: '', //전소유자명
				sellPrice_S: '', //매물금액
				sellPrice_E: '',
				sizeP_S: '', //건물평수
				sizeP_E: '',
				sizeM_S: '', //건물면적
				sizeM_E: '',
				roadWide_S: '', //도로너비
				roadWide_E: '',
				roadConer: '', //코너
				roadDual: '', //양면
				roadName: '', //도로명
				memUid: '', //담당자
				regDate_S: '', //매물등록일자
				regDate_E: '',
				phone: '', //전화번호
				cateList: [], //매물종류
				sellDate_S: '', //매매일자
				sellDate_E: '',
				remodelDate_S: '', //리모델링일
				remodelDate_E: '',
				buildDate_S: '', //준공일자
				buildDate_E: '',
				landSizePy: '', //토지평단가
				totalSizePy: '', //연면적평단가
				teamId: '', //부서/팀
				cateId: '', //팀
			},
			searchOptions_: {
				mode: 0,
				keyword: '',
				state: {
					st: false,
					st_: ['done'],
				},
				bName: '', //물건명
				oName: '', //소유자명
				useList: [], //용도지역
				lp_S: '', //대지평수
				lp_E: '',
				lm_S: '', //대지면적
				lm_E: '',
				er_S: '', //연수익률
				er_E: '',
				sub: '', //주변역
				dis: '', //거리
				floor_S: '', //층수
				floor_E: '',
				stList: [], //상태
				bId: '', //물건번호
				preOName: '', //전소유자명
				sellPrice_S: '', //매물금액
				sellPrice_E: '',
				sizeP_S: '', //건물평수
				sizeP_E: '',
				sizeM_S: '', //건물면적
				sizeM_E: '',
				roadWide_S: '', //도로너비
				roadWide_E: '',
				roadConer: '', //코너
				roadDual: '', //양면
				roadName: '', //도로명
				memUid: '', //담당자
				regDate_S: '', //매물등록일자
				regDate_E: '',
				phone: '', //전화번호
				cateList: [], //매물종류
				sellDate_S: '', //매매일자
				sellDate_E: '',
				remodelDate_S: '', //리모델링일
				remodelDate_E: '',
				buildDate_S: '', //준공일자
				buildDate_E: '',
				landSizePy: '', //토지평단가
				totalSizePy: '', //연면적평단가
				teamId: '', //부서/팀
				cateId: '', //팀
			},
			isTooltipShow: false,
			tooltipName: '',

			page: 1,
			totalCount: null,
			itemSize: 20,
			blockSize: 5,
			pageData: null,

			onTg: true,

			bdCateList: [],
			useAreaList: [],
			teamList: [],
			cateList: [],
			memList: [],
		};
	},
	updated() {},
	created() {
		window.setZoom = this.setZoom;
		window.getItem = this.getItem;
		window.btnInfoNext = this.btnInfoNext;
		window.closeInfo = this.closeInfo;
		window.openDetail = this.openDetail;

		this.searchOptions.bId = this.$route.query.isId;
		this.searchOptions_.bId = this.$route.query.isId;
		this.searchOptions.state.st_ = [this.$route.query.st];
		this.searchOptions_.state.st_ = [this.$route.query.st];

		this.getItemPage(this.page);
		this.init();
	},
	mounted() {
		const mapTooltip = document.querySelector('.map-tooltip');
		document.addEventListener('mousemove', e => {
			const mouseX = e.clientX;
			const mouseY = e.clientY;

			mapTooltip.style.left = mouseX + 20 + 'px';
			mapTooltip.style.top = mouseY + 20 + 'px';
		});
	},
	beforeUnmount() {
		clearTimeout(this.idleTimer);
	},
	methods: {
		init() {
			this.$apiGET('/admin/api/map/bdCate').then(data => {
				this.bdCateList = data;
			});
			this.$apiGET('/admin/api/map/useArea').then(data => {
				this.useAreaList = data;
			});
			// this.$apiGET('/admin/api/map/team').then(data => {
			// 	this.teamList = data;
			// });
			this.$apiGET('/admin/api/mem/code?part=team').then(data => {
				this.teamList = data;
			});
			this.$apiGET('/admin/api/mem/code?part=team_cate').then(data => {
				this.cateList = data;
			});
			this.$apiGET('/admin/api/setting/etc/mem').then(data => {
				this.memList = data;
			});
		},
		addTag(newTag) {
			const tag = {
				name: newTag,
				code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
			};
			this.options.push(tag);
			this.value.push(tag);
		},
		removeItemList(itemList_) {
			for (const [key] of Object.entries(this.marker)) {
				let fg = false;
				for (let i = 0; i < itemList_.length; i++) {
					if (key == itemList_[i].bid) {
						fg = true;
					}
				}

				if (!fg) {
					delete this.marker[key];
				}
			}
		},
		setZoom(lng, lat, level, fg) {
			this.map.setCenter({ lat: lat, lng: lng });
			// this.map.setZoom(17, true);
			this.map.setZoom(level, fg);
		},
		closeInfo(e) {
			if (e) {
				if (e.stopPropagation) e.stopPropagation();
				else e.cancelBubble = true; // IE 대응
			}

			this.isInfo = null;
			if (this.infoWindow && this.infoWindow.getMap()) {
				this.infoWindow.close();
			}
		},
		onZoomChanged() {},
		onIdleDebounced() {
			clearTimeout(this.idleTimer);
			this.idleTimer = setTimeout(() => {
				this.onDrawMarker(false).catch(() => {});
			}, 400);
		},
		async onDrawMarker(fg) {
			if (this.isLoadingMarkers && !fg) {
				this.loadRequestId++; // Invalidate stale in-flight writes
				this.pendingRefresh = true;
				return;
			}
			if (this.isLoadingMarkers && fg) {
				// Cancel the existing load's state writes
				this.loadRequestId++;
			}
			this.isLoadingMarkers = true;
			this.pendingRefresh = false;
			const requestId = ++this.loadRequestId;
			try {
				const pos = this.map.getBounds();
				const zoom = this.map.getZoom();

				if (zoom <= 11) {
					this.itemList = [];
					this.itemDongList = [];
					this.itemGuList = [];
					this.itemBizList = [];
					this.closeInfo();
					this.isInfo = null;
					await this.getItemSidoList(pos._min._lat, pos._max._lat, pos._min._lng, pos._max._lng, requestId);
				} else if (zoom >= 12 && zoom <= 14) {
					this.itemList = [];
					this.itemDongList = [];
					this.itemSidoList = [];
					this.itemBizList = [];
					this.closeInfo();
					this.isInfo = null;
					await this.getItemGuList(pos._min._lat, pos._max._lat, pos._min._lng, pos._max._lng, requestId);
				} else if (zoom >= 15 && zoom <= 16) {
					this.itemList = [];
					this.itemGuList = [];
					this.itemSidoList = [];
					this.itemBizList = [];
					this.closeInfo();
					this.isInfo = null;
					await this.getItemDongList(pos._min._lat, pos._max._lat, pos._min._lng, pos._max._lng, requestId);
				} else if (zoom >= 17) {
					this.itemDongList = [];
					this.itemGuList = [];
					this.itemSidoList = [];
					await this.getItemList(pos._min._lat, pos._max._lat, pos._min._lng, pos._max._lng, fg, requestId);
					if (this.loadRequestId !== requestId) return;
					if (this.isBizActive) {
						await this.getItemBizList(pos._min._lat, pos._max._lat, pos._min._lng, pos._max._lng, requestId);
					} else {
						this.itemBizList = [];
					}
				}
			} finally {
				this.isLoadingMarkers = false;
				if (this.pendingRefresh) {
					this.pendingRefresh = false;
					this.onDrawMarker(false).catch(() => {});
				}
			}
		},
		onLoadMap(mapObject) {
			this.map = mapObject;
			this.map.setSize({ width: '1371px', height: '1024px' });

			this.mapType = new window.naver.maps.CadastralLayer();
			this.onDrawMarker(false).catch(() => {});
		},
		onLoadInfoWindow(infoWindowObject) {
			this.infoWindow = infoWindowObject;
		},
		onLoadMarker(markerObject, item) {
			// this.marker = markerObject;
			this.marker[item.bid] = markerObject;

			const aa = parseInt(item.size_py_price * 0.01) * 100;
			const bb = parseInt(item.price * 0.001) * 1000;

			const size_py_price = this.formatMoney(aa, this.MONEY_FORMAT_TYPE.MUCH);
			const price = this.formatMoney(bb, this.MONEY_FORMAT_TYPE.MUCH);

			let stColor = '';
			//준비 진화색 2, 매물 파란 1, 보류 연회 3, 매각 빨간 4
			if (item.state == 'done') {
				stColor = 'type-1';
			} else if (item.state == 'ready') {
				stColor = 'type-2';
			} else if (item.state == 'hold') {
				stColor = 'type-3';
			} else if (item.state == 'sell') {
				stColor = 'type-4';
			}

			this.marker[item.bid].setIcon({
				icon: 'HtmlIcon',
				content: `<div class="map-pin ${stColor}" onClick="window.getItem(${item.bid})">
									<p>평<span class="count">${size_py_price}</span></p>
									<p>매<span class="count">${price}</span></p>
								</div>`,
			});

			// vue.marker.setIcon({
			// 	content: `<div  class="count sm"
			//     style="left: 20px; top: 20px"
			//     onClick="window.listSelect('${item.Id}')">${item.AvailCount}</div>`,
			// });
		},
		onLoadDongMarker(markerObject, item) {
			this.marker2 = markerObject;
			// console.log(item);

			let str = '';
			let cnt = 0;

			for (let i = 0; i < item.length; i++) {
				str += `<p class="text">${this.ITEM_STATE[item[i].state]} ${item[i].cnt}건</p>`;
				cnt += item[i].cnt;
			}

			this.marker2.setIcon({
				content: `<div class="map-circle" onClick="window.setZoom(${item[0].pt.x},${item[0].pt.y},17,${true})">
								<p class="count">${cnt}</p>
								<p class="text">${item[0].name}</p>
							${str}
						</div>`,
			});
		},
		onLoadPolygon(polygonObject) {
			this.polygon = polygonObject;

			this.polygon.setOptions({
				fillColor: 'red',
				fillOpacity: 0.3,
				strokeColor: 'red',
				strokeOpacity: 0.6,
				clickable: true,
			});
		},
		onMouseupPolygon(ev, name) {
			this.tooltipName = name;
			this.isTooltipShow = true;
			//document.querySelector('.map-tooltip').style.left = ev.point.x + 'px';
			//document.querySelector('.map-tooltip').style.top = ev.point.y + 'px';
			ev.overlay.setOptions({
				strokeWeight: 3.5,
			});
		},
		onMouseoutPolygon(ev) {
			this.isTooltipShow = false;
			ev.overlay.setOptions({
				strokeWeight: 1,
			});
		},
		openDetail(cid) {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			window.open('/MapDetail/' + cid, '', attr);
		},
		getItem(bid) {
			this.isInfo = null;

			// if (this.infoWindow && this.infoWindow.getMap()) {
			// 	this.infoWindow.close();
			// }
			this.infoList = [];
			for (const [key, value] of Object.entries(this.marker)) {
				if (this.objCompare(value.position, this.marker[bid].position)) {
					this.infoList.push(Number(key));
				}
			}

			const idx = this.infoList.indexOf(bid);

			let but = '';

			if (idx != 0) {
				but += `<button type="button" class="btn" onClick="window.btnInfoNext(event, ${this.infoList[idx - 1]})">
					<svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path></svg>
					</button>`;
			}
			but += `${idx + 1}`;
			if (idx + 1 != this.infoList.length) {
				but += `<button type="button" class="btn" onClick="window.btnInfoNext(event, ${this.infoList[idx + 1]})">
					<svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"></path></svg>
					</button>`;
			}
			let imgUrl = process.env.VUE_APP_HOST_BACK + '/users/item/image?id=';

			this.$apiGET('/admin/api/map/getItem?bid=' + bid).then(data => {
				this.thisItem = data;
				imgUrl += data.img + '&w=400&q=82';
				this.infoWindow = new window.naver.maps.InfoWindow({
					disableAnchor: true,
					backgroundColor: 'transparent',
					pixelOffset: new window.naver.maps.Point(0, -58),
					borderWidth: 0,
					content: `<div class="map-detail" onClick="window.openDetail(${bid})">
										<div class="top">
											${this.thisItem.building_name}
											<button type="button" class="btn btn-close" onClick="window.closeInfo(event)"><b-icon-x-lg /></button>
										</div>
										<div class="con">
											<div class="img-wrap">
												<img src="${imgUrl}" width="100" height="100" alt="" />
											</div>
											<div class="text">
												<p><strong>주소 : </strong>${this.$normalizeAddr(this.thisItem.jibun_addr)}</p>
												<p><strong>대지 : </strong>${this.$formatArea(this.thisItem.land_size_p)}(평) / 연면적 : ${this.$formatArea(this.thisItem.total_size_p)}(평)</p>
												<p><strong>규모 : </strong>${this.getFloorString(this.thisItem.floor_cnt_B, this.thisItem.floor_cnt_F)}</p>
												<p><strong>매매금액 : </strong>${this.$formatMoney(this.thisItem.sell_price, 'COMPACT')}</p>
												<p><strong>토지평단가 : </strong>${this.$formatMoney(this.thisItem.land_size_py_price, 'COMPACT')}</p>
												<p><strong>연면적평단가 : </strong>${this.$formatMoney(
													this.thisItem.total_size_py_price,
													'COMPACT',
												)}</p>
											</div>
										</div>

										<div class="btn-wrap">${but}</div>
									</div>`,
				});

				this.isInfo = bid;
				this.infoWindow.open(this.map, this.marker[bid]);
			});
		},
		getItemPage(pg) {
			this.$apiGET(
				'/admin/api/mapPage' +
					'?page=' +
					(pg - 1) * this.itemSize +
					'&st_=' +
					this.searchOptions.state.st_ +
					'&keyword=' +
					this.searchOptions.keyword +
					'&bName=' +
					this.searchOptions.bName +
					'&oName=' +
					this.searchOptions.oName +
					'&useList=' +
					this.searchOptions.useList +
					'&lp_S=' +
					this.searchOptions.lp_S +
					'&lp_E=' +
					this.searchOptions.lp_E +
					'&er_S=' +
					this.searchOptions.er_S +
					'&er_E=' +
					this.searchOptions.er_E +
					'&sub=' +
					this.searchOptions.sub +
					'&dis=' +
					this.searchOptions.dis +
					'&floor_S=' +
					this.searchOptions.floor_S +
					'&floor_E=' +
					this.searchOptions.floor_E +
					'&stList=' +
					this.searchOptions.stList +
					'&bId=' +
					this.searchOptions.bId +
					'&preOName=' +
					this.searchOptions.preOName +
					'&sellPrice_S=' +
					this.searchOptions.sellPrice_S +
					'&sellPrice_E=' +
					this.searchOptions.sellPrice_E +
					'&sizeP_S=' +
					this.searchOptions.sizeP_S +
					'&sizeP_E=' +
					this.searchOptions.sizeP_E +
					'&roadWide_S=' +
					this.searchOptions.roadWide_S +
					'&roadWide_E=' +
					this.searchOptions.roadWide_E +
					'&roadConer=' +
					this.searchOptions.roadConer +
					'&roadDual=' +
					this.searchOptions.roadDual +
					'&roadName=' +
					this.searchOptions.roadName +
					'&memUid=' +
					this.searchOptions.memUid +
					'&regDate_S=' +
					this.searchOptions.regDate_S +
					'&regDate_E=' +
					this.searchOptions.regDate_E +
					'&phone=' +
					this.searchOptions.phone +
					'&cateList=' +
					this.searchOptions.cateList +
					'&sellDate_S=' +
					this.searchOptions.sellDate_S +
					'&sellDate_E=' +
					this.searchOptions.sellDate_E +
					'&remodelDate_S=' +
					this.searchOptions.remodelDate_S +
					'&remodelDate_E=' +
					this.searchOptions.remodelDate_E +
					'&buildDate_S=' +
					this.searchOptions.buildDate_S +
					'&buildDate_E=' +
					this.searchOptions.buildDate_E +
					'&landSizePy=' +
					this.searchOptions.landSizePy +
					'&totalSizePy=' +
					this.searchOptions.totalSizePy +
					'&teamId=' +
					this.searchOptions.teamId +
					'&cateId=' +
					this.searchOptions.cateId +
					'&isRent=false',
			).then(data => {
				this.pageItemList = data.item;
				this.totalCount = data.pageInfo.totalCount;
				this.page = pg;
				this.pageData = this.pageDataSetting(this.totalCount, this.itemSize, this.blockSize, this.page);

				if (this.onTg) {
					this.onTg = false;
					this.clearSearch();
					this.$nextTick(() => {
						setTimeout(
							function () {
								this.btnItemPage(this.pageItemList[0].pt.x, this.pageItemList[0].pt.y, 21, this.pageItemList[0].bid);
							}.bind(this),
							250,
						);
					});
				}
			});
		},
		async getItemList(lat_min, lat_max, lng_min, lng_max, fg, requestId) {
			await this.$apiGET(
				'/admin/api/map?lat_min=' +
					lat_min +
					'&lat_max=' +
					lat_max +
					'&lng_min=' +
					lng_min +
					'&lng_max=' +
					lng_max +
					'&st_=' +
					this.searchOptions.state.st_ +
					'&keyword=' +
					this.searchOptions.keyword +
					'&mode=' +
					this.searchOptions.mode +
					'&bName=' +
					this.searchOptions.bName +
					'&oName=' +
					this.searchOptions.oName +
					'&useList=' +
					this.searchOptions.useList +
					'&lp_S=' +
					this.searchOptions.lp_S +
					'&lp_E=' +
					this.searchOptions.lp_E +
					'&er_S=' +
					this.searchOptions.er_S +
					'&er_E=' +
					this.searchOptions.er_E +
					'&sub=' +
					this.searchOptions.sub +
					'&dis=' +
					this.searchOptions.dis +
					'&floor_S=' +
					this.searchOptions.floor_S +
					'&floor_E=' +
					this.searchOptions.floor_E +
					'&stList=' +
					this.searchOptions.stList +
					'&bId=' +
					this.searchOptions.bId +
					'&preOName=' +
					this.searchOptions.preOName +
					'&sellPrice_S=' +
					this.searchOptions.sellPrice_S +
					'&sellPrice_E=' +
					this.searchOptions.sellPrice_E +
					'&sizeP_S=' +
					this.searchOptions.sizeP_S +
					'&sizeP_E=' +
					this.searchOptions.sizeP_E +
					'&roadWide_S=' +
					this.searchOptions.roadWide_S +
					'&roadWide_E=' +
					this.searchOptions.roadWide_E +
					'&roadConer=' +
					this.searchOptions.roadConer +
					'&roadDual=' +
					this.searchOptions.roadDual +
					'&roadName=' +
					this.searchOptions.roadName +
					'&memUid=' +
					this.searchOptions.memUid +
					'&regDate_S=' +
					this.searchOptions.regDate_S +
					'&regDate_E=' +
					this.searchOptions.regDate_E +
					'&phone=' +
					this.searchOptions.phone +
					'&cateList=' +
					this.searchOptions.cateList +
					'&sellDate_S=' +
					this.searchOptions.sellDate_S +
					'&sellDate_E=' +
					this.searchOptions.sellDate_E +
					'&remodelDate_S=' +
					this.searchOptions.remodelDate_S +
					'&remodelDate_E=' +
					this.searchOptions.remodelDate_E +
					'&buildDate_S=' +
					this.searchOptions.buildDate_S +
					'&buildDate_E=' +
					this.searchOptions.buildDate_E +
					'&landSizePy=' +
					this.searchOptions.landSizePy +
					'&totalSizePy=' +
					this.searchOptions.totalSizePy +
					'&teamId=' +
					this.searchOptions.teamId +
					'&cateId=' +
					this.searchOptions.cateId +
					'&isRent=false',
			).then(data => {
				if (requestId !== undefined && requestId !== this.loadRequestId) return;
				this.removeItemList(data);
				if (fg) {
					this.itemList = data;
				} else if (this.itemList.length > 250) {
					setTimeout(() => {
						if (requestId !== undefined && requestId !== this.loadRequestId) return;
						this.itemList = data;
					}, 250);
				} else if (this.itemList.length > 100) {
					setTimeout(() => {
						if (requestId !== undefined && requestId !== this.loadRequestId) return;
						this.itemList = data;
					}, 100);
				} else {
					this.itemList = data;
				}
			});
		},
		async getItemDongList(lat_min, lat_max, lng_min, lng_max, requestId) {
			return this.$apiGET(
				'/admin/api/map/dong?lat_min=' +
					lat_min +
					'&lat_max=' +
					lat_max +
					'&lng_min=' +
					lng_min +
					'&lng_max=' +
					lng_max +
					'&st_=' +
					this.searchOptions.state.st_ +
					'&keyword=' +
					this.searchOptions.keyword +
					'&mode=' +
					this.searchOptions.mode +
					'&bName=' +
					this.searchOptions.bName +
					'&oName=' +
					this.searchOptions.oName +
					'&useList=' +
					this.searchOptions.useList +
					'&lp_S=' +
					this.searchOptions.lp_S +
					'&lp_E=' +
					this.searchOptions.lp_E +
					'&er_S=' +
					this.searchOptions.er_S +
					'&er_E=' +
					this.searchOptions.er_E +
					'&sub=' +
					this.searchOptions.sub +
					'&dis=' +
					this.searchOptions.dis +
					'&floor_S=' +
					this.searchOptions.floor_S +
					'&floor_E=' +
					this.searchOptions.floor_E +
					'&stList=' +
					this.searchOptions.stList +
					'&bId=' +
					this.searchOptions.bId +
					'&preOName=' +
					this.searchOptions.preOName +
					'&sellPrice_S=' +
					this.searchOptions.sellPrice_S +
					'&sellPrice_E=' +
					this.searchOptions.sellPrice_E +
					'&sizeP_S=' +
					this.searchOptions.sizeP_S +
					'&sizeP_E=' +
					this.searchOptions.sizeP_E +
					'&roadWide_S=' +
					this.searchOptions.roadWide_S +
					'&roadWide_E=' +
					this.searchOptions.roadWide_E +
					'&roadConer=' +
					this.searchOptions.roadConer +
					'&roadDual=' +
					this.searchOptions.roadDual +
					'&roadName=' +
					this.searchOptions.roadName +
					'&memUid=' +
					this.searchOptions.memUid +
					'&regDate_S=' +
					this.searchOptions.regDate_S +
					'&regDate_E=' +
					this.searchOptions.regDate_E +
					'&phone=' +
					this.searchOptions.phone +
					'&cateList=' +
					this.searchOptions.cateList +
					'&sellDate_S=' +
					this.searchOptions.sellDate_S +
					'&sellDate_E=' +
					this.searchOptions.sellDate_E +
					'&remodelDate_S=' +
					this.searchOptions.remodelDate_S +
					'&remodelDate_E=' +
					this.searchOptions.remodelDate_E +
					'&buildDate_S=' +
					this.searchOptions.buildDate_S +
					'&buildDate_E=' +
					this.searchOptions.buildDate_E +
					'&landSizePy=' +
					this.searchOptions.landSizePy +
					'&totalSizePy=' +
					this.searchOptions.totalSizePy +
					'&teamId=' +
					this.searchOptions.teamId +
					'&cateId=' +
					this.searchOptions.cateId +
					'&isRent=false',
			).then(data => {
				if (requestId !== undefined && requestId !== this.loadRequestId) return;
				this.itemDongList = this.groupBy(data, 'code');
			});
		},
		async getItemGuList(lat_min, lat_max, lng_min, lng_max, requestId) {
			return this.$apiGET(
				'/admin/api/map/gu?lat_min=' +
					lat_min +
					'&lat_max=' +
					lat_max +
					'&lng_min=' +
					lng_min +
					'&lng_max=' +
					lng_max +
					'&st_=' +
					this.searchOptions.state.st_ +
					'&keyword=' +
					this.searchOptions.keyword +
					'&mode=' +
					this.searchOptions.mode +
					'&bName=' +
					this.searchOptions.bName +
					'&oName=' +
					this.searchOptions.oName +
					'&useList=' +
					this.searchOptions.useList +
					'&lp_S=' +
					this.searchOptions.lp_S +
					'&lp_E=' +
					this.searchOptions.lp_E +
					'&er_S=' +
					this.searchOptions.er_S +
					'&er_E=' +
					this.searchOptions.er_E +
					'&sub=' +
					this.searchOptions.sub +
					'&dis=' +
					this.searchOptions.dis +
					'&floor_S=' +
					this.searchOptions.floor_S +
					'&floor_E=' +
					this.searchOptions.floor_E +
					'&stList=' +
					this.searchOptions.stList +
					'&bId=' +
					this.searchOptions.bId +
					'&preOName=' +
					this.searchOptions.preOName +
					'&sellPrice_S=' +
					this.searchOptions.sellPrice_S +
					'&sellPrice_E=' +
					this.searchOptions.sellPrice_E +
					'&sizeP_S=' +
					this.searchOptions.sizeP_S +
					'&sizeP_E=' +
					this.searchOptions.sizeP_E +
					'&roadWide_S=' +
					this.searchOptions.roadWide_S +
					'&roadWide_E=' +
					this.searchOptions.roadWide_E +
					'&roadConer=' +
					this.searchOptions.roadConer +
					'&roadDual=' +
					this.searchOptions.roadDual +
					'&roadName=' +
					this.searchOptions.roadName +
					'&memUid=' +
					this.searchOptions.memUid +
					'&regDate_S=' +
					this.searchOptions.regDate_S +
					'&regDate_E=' +
					this.searchOptions.regDate_E +
					'&phone=' +
					this.searchOptions.phone +
					'&cateList=' +
					this.searchOptions.cateList +
					'&sellDate_S=' +
					this.searchOptions.sellDate_S +
					'&sellDate_E=' +
					this.searchOptions.sellDate_E +
					'&remodelDate_S=' +
					this.searchOptions.remodelDate_S +
					'&remodelDate_E=' +
					this.searchOptions.remodelDate_E +
					'&buildDate_S=' +
					this.searchOptions.buildDate_S +
					'&buildDate_E=' +
					this.searchOptions.buildDate_E +
					'&landSizePy=' +
					this.searchOptions.landSizePy +
					'&totalSizePy=' +
					this.searchOptions.totalSizePy +
					'&teamId=' +
					this.searchOptions.teamId +
					'&cateId=' +
					this.searchOptions.cateId +
					'&isRent=false',
			).then(data => {
				if (requestId !== undefined && requestId !== this.loadRequestId) return;
				this.itemGuList = this.groupBy(data, 'code');
			});
		},
		async getItemSidoList(lat_min, lat_max, lng_min, lng_max, requestId) {
			return this.$apiGET(
				'/admin/api/map/sido?lat_min=' +
					lat_min +
					'&lat_max=' +
					lat_max +
					'&lng_min=' +
					lng_min +
					'&lng_max=' +
					lng_max +
					'&st_=' +
					this.searchOptions.state.st_ +
					'&keyword=' +
					this.searchOptions.keyword +
					'&mode=' +
					this.searchOptions.mode +
					'&bName=' +
					this.searchOptions.bName +
					'&oName=' +
					this.searchOptions.oName +
					'&useList=' +
					this.searchOptions.useList +
					'&lp_S=' +
					this.searchOptions.lp_S +
					'&lp_E=' +
					this.searchOptions.lp_E +
					'&er_S=' +
					this.searchOptions.er_S +
					'&er_E=' +
					this.searchOptions.er_E +
					'&sub=' +
					this.searchOptions.sub +
					'&dis=' +
					this.searchOptions.dis +
					'&floor_S=' +
					this.searchOptions.floor_S +
					'&floor_E=' +
					this.searchOptions.floor_E +
					'&stList=' +
					this.searchOptions.stList +
					'&bId=' +
					this.searchOptions.bId +
					'&preOName=' +
					this.searchOptions.preOName +
					'&sellPrice_S=' +
					this.searchOptions.sellPrice_S +
					'&sellPrice_E=' +
					this.searchOptions.sellPrice_E +
					'&sizeP_S=' +
					this.searchOptions.sizeP_S +
					'&sizeP_E=' +
					this.searchOptions.sizeP_E +
					'&roadWide_S=' +
					this.searchOptions.roadWide_S +
					'&roadWide_E=' +
					this.searchOptions.roadWide_E +
					'&roadConer=' +
					this.searchOptions.roadConer +
					'&roadDual=' +
					this.searchOptions.roadDual +
					'&roadName=' +
					this.searchOptions.roadName +
					'&memUid=' +
					this.searchOptions.memUid +
					'&regDate_S=' +
					this.searchOptions.regDate_S +
					'&regDate_E=' +
					this.searchOptions.regDate_E +
					'&phone=' +
					this.searchOptions.phone +
					'&cateList=' +
					this.searchOptions.cateList +
					'&sellDate_S=' +
					this.searchOptions.sellDate_S +
					'&sellDate_E=' +
					this.searchOptions.sellDate_E +
					'&remodelDate_S=' +
					this.searchOptions.remodelDate_S +
					'&remodelDate_E=' +
					this.searchOptions.remodelDate_E +
					'&buildDate_S=' +
					this.searchOptions.buildDate_S +
					'&buildDate_E=' +
					this.searchOptions.buildDate_E +
					'&landSizePy=' +
					this.searchOptions.landSizePy +
					'&totalSizePy=' +
					this.searchOptions.totalSizePy +
					'&teamId=' +
					this.searchOptions.teamId +
					'&cateId=' +
					this.searchOptions.cateId +
					'&isRent=false',
			).then(data => {
				if (requestId !== undefined && requestId !== this.loadRequestId) return;
				this.itemSidoList = this.groupBy(data, 'code');
			});
		},
		async getItemBizList(lat_min, lat_max, lng_min, lng_max, requestId) {
			return this.$apiGET(
				'/admin/api/map/biz?lat_min=' + lat_min + '&lat_max=' + lat_max + '&lng_min=' + lng_min + '&lng_max=' + lng_max,
			).then(data => {
				if (requestId !== undefined && requestId !== this.loadRequestId) return;
				// this.itemBizList = data;
				// console.log(data[0].geo[0]);
				// console.log(Object.entries(data[0].geo[0]));
				if (data.length) {
					for (let i = 0; i < data.length; i++) {
						let tt = [];
						if (data[i].geo.length) {
							for (let ii = 0; ii < data[i].geo[0].length; ii++) {
								tt.push(Object.values(data[i].geo[0][ii]));
							}
							data[i].pos = tt;
						}
					}
				}

				this.itemBizList = data;
			});
		},
		async btnItemPage(lng, lat, level, bid) {
			this.setZoom(lng, lat, level, false);
			await this.onDrawMarker(true);
			this.getItem(bid);
		},
		btnMapListActive(st) {
			this.isMapListActive = st;

			if (this.isMapListActive) {
				this.map.setSize({ width: '1828px', height: '1024px' });
				// this.map.refresh();
				// <!-- 1828 1371px-->
			} else {
				this.map.setSize({ width: '1371px', height: '1024px' });
			}
		},
		btnInfoNext(e, bid) {
			if (e.stopPropagation) e.stopPropagation();
			else e.cancelBubble = true; // IE 대응
			this.getItem(bid);
		},
		// btnMarker1(id) {
		// 	if (this.infoWindow && this.infoWindow.getMap()) {
		// 		this.infoWindow.close();
		// 	}

		// 	// let isIdx = null;
		// 	// for (let i = 0; i < this.itemList.length; i++) {
		// 	// 	if (id == this.itemList[i].bid) {
		// 	// 		isIdx = i;
		// 	// 		break;
		// 	// 	}
		// 	// }

		// 	// if (!isIdx) {
		// 	// 	return;
		// 	// }

		// 	this.getItem(id);

		// 	// console.log('1 :' + this.formatMoney(item, this.MONEY_FORMAT_TYPE.LITTLE));
		// 	// console.log('1 :' + this.formatMoney(item, this.MONEY_FORMAT_TYPE.MUCH));
		// 	// console.log('1 :' + this.formatMoney(item, this.MONEY_FORMAT_TYPE.LOAN));
		// 	// console.log('1 :' + this.formatMoney(item, this.MONEY_FORMAT_TYPE.RANGE));
		// 	// console.log('1 :' + this.formatMoney(item, this.MONEY_FORMAT_TYPE.TAX));
		// 	// console.log('1 :' + this.formatMoney(item, this.MONEY_FORMAT_TYPE.MOBILE));
		// 	// console.log('1 :' + this.formatMoney(item, this.MONEY_FORMAT_TYPE.MOBILE2));
		// },
		btnBizActive(st) {
			this.isBizActive = st;
			// console.log(st);
			this.onDrawMarker(false).catch(() => {});
		},
		btnZoomLevel(st) {
			this.map.setZoom(this.map.getZoom() + st, true);
		},
		btnMapType() {
			this.isCad = !this.isCad;

			if (this.isCad) {
				this.mapType.setMap(this.map);
			} else {
				this.mapType.setMap(null);
			}
		},
		btnStOption() {
			if (this.searchOptions_.state.st) {
				this.searchOptions_.state.st_ = ['sell', 'ready', 'hold', 'done'];
			} else {
				this.searchOptions_.state.st_ = [];
			}
		},
		btnStOptionWithSearch() {
			this.btnStOption();
			this.btnSearch();
		},
		btnSearch() {
			this.searchOptions = JSON.parse(JSON.stringify(this.searchOptions_));

			if (this.infoWindow && this.infoWindow.getMap()) {
				this.infoWindow.close();
			}
			this.isInfo = null;

			let st_ = false;
			for (const [key, value] of Object.entries(this.searchOptions_)) {
				if (!(key == 'mode' || key == 'state')) {
					// console.log(`${key}: ${this.isEmpty(value)}`);
					if (this.isEmpty(value)) {
						st_ = true;
						break;
					}
				}
			}

			if (st_) {
				this.searchOptions.mode = 1;
			} else {
				this.searchOptions.mode = 0;
			}

			// console.log(this.searchOptions.useList);
			this.searchOptions.useList = [];
			for (let i = 0; i < this.searchOptions_.useList.length; i++) {
				this.searchOptions.useList.push(this.searchOptions_.useList[i].id);
			}

			this.searchOptions.cateList = [];
			for (let i = 0; i < this.searchOptions_.cateList.length; i++) {
				this.searchOptions.cateList.push(this.searchOptions_.cateList[i].id);
			}

			// lp_S; //대지평수
			if (this.searchOptions.lp_S == '' && this.searchOptions.lp_E != '') {
				this.searchOptions.lp_S = 0;
			} else if (this.searchOptions.lp_S != '' && this.searchOptions.lp_E == '') {
				this.searchOptions.lp_E = 99999999;
			}

			// er_S; //연수익률
			if (this.searchOptions.er_S == '' && this.searchOptions.er_E != '') {
				this.searchOptions.er_S = 0;
			} else if (this.searchOptions.er_S != '' && this.searchOptions.er_E == '') {
				this.searchOptions.er_E = 999;
			}

			// floor_S; //층수
			if (this.searchOptions.floor_S == '' && this.searchOptions.floor_E != '') {
				this.searchOptions.floor_S = 0;
			} else if (this.searchOptions.floor_S != '' && this.searchOptions.floor_E == '') {
				this.searchOptions.floor_E = 999;
			}

			// sellPrice_S;	//매물금액
			if (this.searchOptions.sellPrice_S == '' && this.searchOptions.sellPrice_E != '') {
				this.searchOptions.sellPrice_S = 0;
			} else if (this.searchOptions.sellPrice_S != '' && this.searchOptions.sellPrice_E == '') {
				this.searchOptions.sellPrice_E = 99999999;
			}

			// sizeP_S;	//건물평수
			if (this.searchOptions.sizeP_S == '' && this.searchOptions.sizeP_E != '') {
				this.searchOptions.sizeP_S = 0;
			} else if (this.searchOptions.sizeP_S != '' && this.searchOptions.sizeP_E == '') {
				this.searchOptions.sizeP_E = 99999999;
			}

			// roadWide_S; //도로너비
			if (this.searchOptions.roadWide_S == '' && this.searchOptions.roadWide_E != '') {
				this.searchOptions.roadWide_S = 0;
			} else if (this.searchOptions.roadWide_S != '' && this.searchOptions.roadWide_E == '') {
				this.searchOptions.roadWide_E = 32767;
			}

			//regDate_S; //매물등록일자
			if (this.searchOptions.regDate_S == '' && this.searchOptions.regDate_E != '') {
				this.searchOptions.regDate_S = '1900-01-01';
			} else if (this.searchOptions.regDate_S != '' && this.searchOptions.regDate_E == '') {
				this.searchOptions.regDate_E = '2999-01-01';
			}

			// sellDate_S; //매매일자
			if (this.searchOptions.sellDate_S == '' && this.searchOptions.sellDate_E != '') {
				this.searchOptions.sellDate_S = '1900-01-01';
			} else if (this.searchOptions.sellDate_S != '' && this.searchOptions.sellDate_E == '') {
				this.searchOptions.sellDate_E = '2999-01-01';
			}

			// remodelDate_S; //리모델링일
			if (this.searchOptions.remodelDate_S == '' && this.searchOptions.remodelDate_E != '') {
				this.searchOptions.remodelDate_S = '1900-01-01';
			} else if (this.searchOptions.remodelDate_S != '' && this.searchOptions.remodelDate_E == '') {
				this.searchOptions.remodelDate_E = '2999-01-01';
			}

			// buildDate_S; //준공일자
			if (this.searchOptions.buildDate_S == '' && this.searchOptions.buildDate_E != '') {
				this.searchOptions.buildDate_S = '1900-01-01';
			} else if (this.searchOptions.buildDate_S != '' && this.searchOptions.buildDate_E == '') {
				this.searchOptions.buildDate_E = '2999-01-01';
			}

			this.page = 1;
			// this.map.refresh();
			this.itemList = [];
			this.itemDongList = [];
			this.itemGuList = [];
			this.itemSidoList = [];
			this.itemBizList = [];
			this.getItemPage(this.page);
			this.onDrawMarker(false).catch(() => {});

			this.isDetailSearchPopupShow = false;
		},
		getFloorString(f_B, f_F) {
			// 음수(-1 = 지하 1층)도 그 층수로 읽는다(seon.js 의 getFloorString 과 같다).
			f_B = Math.abs(Number(f_B)) || 0;
			f_F = Math.abs(Number(f_F)) || 0;
			let floor_string = '';
			if (f_B > 0) {
				floor_string = '지하' + f_B + '층';
			}
			if (f_F > 0) {
				if (floor_string != '') {
					floor_string += '/';
				}
				floor_string += '지상' + f_F + '층';
			}
			return floor_string;
		},
		clearSearch() {
			this.searchOptions_ = {
				mode: 0,
				keyword: '',
				state: {
					st: false,
					st_: ['done'],
				},
				bName: '', //물건명
				oName: '', //소유자명
				useList: [], //용도지역
				lp_S: '', //대지평수
				lp_E: '',
				er_S: '', //연수익률
				er_E: '',
				sub: '', //주변역
				dis: '', //거리
				floor_S: '', //층수
				floor_E: '',
				stList: [], //상태
				bId: '', //물건번호
				preOName: '', //전소유자명
				sellPrice_S: '', //매물금액
				sellPrice_E: '',
				sizeP_S: '', //건물평수
				sizeP_E: '',
				roadWide_S: '', //도로너비
				roadWide_E: '',
				roadConer: '', //코너
				roadDual: '', //양면
				roadName: '', //도로명
				memUid: '', //담당자
				regDate_S: '', //매물등록일자
				regDate_E: '',
				phone: '', //전화번호
				cateList: [], //매물종류
				sellDate_S: '', //매매일자
				sellDate_E: '',
				remodelDate_S: '', //리모델링일
				remodelDate_E: '',
				buildDate_S: '', //준공일자
				buildDate_E: '',
				landSizePy: '', //토지평단가
				totalSizePy: '', //연면적평단가
				teamId: '', //부서/팀
				cateId: '',
			};
		},
		numberToKorean(number) {
			return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		},
		formatMoney(e, t, a) {
			return this.c(e, t, !0, a);
		},
		formatMoneyBasedOnWon(e, t, a) {
			var r = e;
			return 'string' == typeof e && (r = parseInt(e, 10)), this.c(r, t, !1, a);
		},
		// F-2.2 (2026-04-15): MUCH / LOAN 브랜치가 seon.js 와 동일하게
		// spec-compliant "N억 M만원" 포맷을 내도록 업데이트. 상세 주석은
		// frontend/src/seon.js 의 c() JSDoc 참조.
		c(e, t, a, r) {
			if ('number' != typeof e) return '0';
			// F-2.2: non-finite 핸들링 (세양 div분할=Infinity 됈) 이후 c() 가 "∞억 NaN만원" 생성하지 않도록 빈 문자열 응답.
			if (!isFinite(e)) return '';
			var l = e,
				o = '',
				i = !1;
			l < 0 && ((l *= -1), (i = !0)), a && (l *= 1e4);
			var s = Math.floor(l / 1e8),
				c = Math.floor(l % 1e8),
				m = Math.floor(c / 1e4),
				p = Math.floor(c % 1e4);
			// F-2.2: 원-scale `l` → 만원 breakdown.
			var totalMan = Math.floor(l / 1e4);
			var eok = Math.floor(totalMan / 1e4);
			var remMan = totalMan - eok * 1e4;
			switch (t) {
				case this.MONEY_FORMAT_TYPE.MUCH:
					// F-2.2: "N억 M만원" 포맷.
					if (0 === l) break;
					if (eok === 0) {
						o = remMan.toLocaleString() + '만원';
					} else if (remMan === 0) {
						o = eok.toLocaleString() + '억';
					} else {
						o = eok.toLocaleString() + '억 ' + remMan.toLocaleString() + '만원';
					}
					break;
				case this.MONEY_FORMAT_TYPE.LITTLE:
					if (0 === l) {
						o = '0';
						break;
					}
					s > 0 && (o = s.toLocaleString() + '억'), m > 0 && (o += m.toLocaleString());
					break;
				case this.MONEY_FORMAT_TYPE.LOAN:
					// F-2.2: "N억 M만원" 포맷.
					if (0 === l) {
						o = '0';
						break;
					}
					if (eok === 0) {
						o = remMan.toLocaleString() + '만원';
					} else if (remMan === 0) {
						o = eok.toLocaleString() + '억';
					} else {
						o = eok.toLocaleString() + '억 ' + remMan.toLocaleString() + '만원';
					}
					break;
				case this.MONEY_FORMAT_TYPE.TAX:
					if (0 === l) {
						o = '-원';
						break;
					}
					s > 0 && (o = s.toLocaleString() + '억'),
						m > 0 && (o += ' ' + m.toLocaleString() + '만'),
						p > 0 && (o += ' ' + p.toLocaleString()),
						(o += '원'),
						o.trim();
					break;
				case this.MONEY_FORMAT_TYPE.MOBILE:
					if (0 === l) {
						o = '0';
						break;
					}
					s > 0 && (o = s.toLocaleString() + '억'), m > 0 && (o += o ? ' ' + m.toLocaleString() : m.toLocaleString());
					break;
				case this.MONEY_FORMAT_TYPE.MOBILE2:
					if (0 === l) {
						o = '0';
						break;
					}
					s > 0 && (o = s.toLocaleString() + '억'),
						m > 0 && (o += o ? ' ' + m.toLocaleString() + '만' : m.toLocaleString() + '만');
			}
			return i && (o = '-' + o), o;
		},
		groupBy(data, key) {
			return data.reduce(function (carry, el) {
				var group = el[key];

				if (carry[group] === undefined) {
					carry[group] = [];
				}

				carry[group].push(el);
				return carry;
			}, {});
		},
		isEmpty(value) {
			if (
				value == '' ||
				value == null ||
				value == undefined ||
				(value != null && typeof value == 'object' && !Object.keys(value).length)
			) {
				return false;
			} else {
				return true;
			}
		},
		pageDataSetting(total, limit, block, page) {
			this.isAllCheck = false;
			const totalPage = Math.ceil(total / limit);
			let currentPage = page;
			const first = currentPage > 1 ? parseInt(currentPage, 10) - parseInt(1, 10) : null;
			const end = totalPage !== currentPage ? parseInt(currentPage, 10) + parseInt(1, 10) : null;

			let startIndex = (Math.ceil(currentPage / block) - 1) * block + 1;
			let endIndex = startIndex + block > totalPage ? totalPage : startIndex + block - 1;
			let list = [];
			for (let index = startIndex; index <= endIndex; index++) {
				list.push(index);
			}
			return { first, end, list, currentPage, totalPage };
		},
		objCompare(pt1, pt2) {
			if (pt1.x === pt2.x && pt1.y === pt2.y) {
				return true;
			}
			return false;
		},
	},
};
</script>

<style>
.infowindow-style {
	color: black;
	background-color: white;
	text-align: center;
	font-weight: 600;
	font-size: 20px;
	padding: 6px 8px;
}
</style>
